import React from 'react';
import { Loader } from './LoaderComponent.styles';

// Define the props interface
interface LoaderComponentProps {
  style?: React.CSSProperties; // Optional style prop
  className?: string; // Optional className prop
}
const LoaderComponent: React.FC<LoaderComponentProps> = ({
  style,
  className,
}) => {
  return (
    <Loader>
      <div
        style={style}
        className={`${
          className?.includes('skeleton-small')
            ? ''
            : style?.height
            ? 'skeleton-mid-large'
            : 'skeleton-mid'
        } ${className ? className : ''}`}
      ></div>
    </Loader>
  );
};
export default LoaderComponent;
